import styled from 'styled-components';

export const CaseScreenHeaderSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const CaseScreenHeaderSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.typography.fontFamily
      : props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
